import React from "react";
import { WrapperMain } from "./Main.styles";

const Main = ({ children, ...props }) => {
    return <WrapperMain {...props}>{children}</WrapperMain>;
};

export default Main;
